export default __webpack_public_path__ + "static/media/4-min.05afa9c9.webp";